import React from 'react';

import { useTranslation } from '@lyearn/i18n';
import { Stack, Typography } from '@lyearn/ui';

function RecurringEventsCount({ eventsCount }: { eventsCount: number }) {
  const { t } = useTranslation();

  const label = t('Events:SessionCount', { humanReadableCount: eventsCount });

  return (
    <Stack
      alignItems="center"
      className="h-24 flex-shrink-0 rounded-24 border border-border px-8 py-1 ms-8"
      justifyContent="center">
      <Typography color="text-text-secondary" data-testid="user-count" variant="body-short-02">
        {label}
      </Typography>
    </Stack>
  );
}

export default React.memo(RecurringEventsCount);
